module.exports = __webpack_public_path__ + "img/kbeauty-2x.095a3442.svg";